Howler.autoUnlock = true;

class AudioWavePlayer extends HTMLElement {

  static currentPlayer = null;

  constructor() {
    super();
  }

  connectedCallback() {

    // ELEMENTS
    this.audio =
      this.querySelector('[data-audio]');

    this.button =
      this.querySelector('[data-play-btn]');

    this.waveform =
      this.querySelector('[data-waveform]');

    this.current =
      this.querySelector('[data-current]');

    this.duration =
      this.querySelector('[data-duration]');

    // DISABLE INITIALLY
    this.button.disabled = true;

    // RESET
    this.waveform.innerHTML = '';

    // HOWLER
    this.sound = new Howl({

      src: [this.audio.src],

      preload: false,

      html5: false,

      xhr: {
        withCredentials: false
      },

      // AUDIO LOADED
      onload: () => {

        // CREATE WAVEFORM
        this.renderWaveform();

        // DURATION
        const duration =
          this.sound.duration() || 0;

        if (this.duration) {

          this.duration.textContent =
            this.formatTime(duration);
        }

        // READY
        this.isLoaded = true;

        // ENABLE BUTTON
        this.button.disabled = false;

        // LOADED CLASS
        this.classList.add(
          'is-loaded'
        );
      },

      // PLAY
      onplay: () => {

        this.classList.add(
          'is-playing'
        );

        this.startProgressLoop();
      },

      // PAUSE
      onpause: () => {

        this.classList.remove(
          'is-playing'
        );

        cancelAnimationFrame(
          this.raf
        );
      },

      // END
      onend: () => {

        this.classList.remove(
          'is-playing'
        );

        cancelAnimationFrame(
          this.raf
        );

        this.resetWave();
      },

      // ERROR
      onloaderror: (id, err) => {

        console.error(
          'Audio Load Error:',
          err
        );
      }
    });

    // PRELOAD AUDIO SILENTLY
    this.sound.load();

    // CLICK
    this.button.addEventListener(
      'click',
      this.toggleAudio.bind(this)
    );
  }

  // CREATE HTML WAVEFORM
  renderWaveform() {

    this.waveform.innerHTML = '';

    const totalBars = 80;

    let html = '';

    for (let i = 0; i < totalBars; i++) {

      const height =
        Math.floor(
          Math.random() * 40
        ) + 5;

      html += `
        <span
          class="wave-bar"
          style="
            height:${height}px;
            animation-delay:${i * 0.02}s;
          ">
        </span>
      `;
    }

    // APPEND HTML
    this.waveform.innerHTML = html;

    // STORE BARS
    this.bars =
      this.waveform.querySelectorAll(
        '.wave-bar'
      );
  }

  // TOGGLE
  toggleAudio() {

    // BLOCK IF NOT READY
    if (!this.isLoaded) return;

    // STOP OTHER PLAYERS
    document
      .querySelectorAll(
        'audio-wave-player'
      )
      .forEach(player => {

        if (
          player !== this &&
          player.sound
        ) {

          player.pauseAudio();
        }
      });

    // PLAY / PAUSE
    if (!this.sound.playing()) {

      this.playAudio();

    } else {

      this.pauseAudio();
    }
  }

  // PLAY
  playAudio() {

    this.sound.play();

    this.classList.add(
      'is-playing'
    );
  }

  // PAUSE
  pauseAudio() {

    this.sound.pause();

    this.classList.remove(
      'is-playing'
    );

    cancelAnimationFrame(
      this.raf
    );
  }

  // LOOP
  startProgressLoop() {

    // SAFETY
    if (
      !this.bars ||
      !this.bars.length
    ) {
      return;
    }

    const update = () => {

      // STOP
      if (
        !this.sound.playing()
      ) return;

      // TIME
      const currentTime =
        this.sound.seek() || 0;

      const duration =
        this.sound.duration() || 0;

      // UPDATE TIME
      if (this.current) {

        this.current.textContent =
          this.formatTime(
            currentTime
          );
      }

      // PROGRESS
      const progress =
        duration > 0
          ? currentTime / duration
          : 0;

      // ACTIVE BARS
      const activeBars =
        Math.floor(
          progress * this.bars.length
        );

      // UPDATE
      this.bars.forEach(
        (bar, index) => {

          if (index <= activeBars) {

            bar.classList.add(
              'active'
            );

          } else {

            bar.classList.remove(
              'active'
            );
          }
        }
      );

      // RAF
      this.raf =
        requestAnimationFrame(
          update
        );
    };

    update();
  }

  // RESET
  resetWave() {

    if (!this.bars) return;

    this.bars.forEach(bar => {

      bar.classList.remove(
        'active'
      );
    });

    if (this.current) {

      this.current.textContent =
        '0:00';
    }
  }

  // FORMAT
  formatTime(time) {

    const minutes =
      Math.floor(time / 60);

    const seconds =
      Math.floor(time % 60)
        .toString()
        .padStart(2, '0');

    return `${minutes}:${seconds}`;
  }
}

// REGISTER
customElements.define(
  'audio-wave-player',
  AudioWavePlayer
);